import en from './en.json';

const normalize = (text) => (typeof text === 'string' ? text.normalize('NFC') : '');
const reverseEn = Object.entries(en).reduce((acc, [tr, enText]) => {
  const normalizedEn = normalize(enText);
  if (normalizedEn) acc[normalizedEn] = tr;
  return acc;
}, {});

export const translateStaticText = (text, lang) => {
  const src = normalize(text);
  if (!src) return '';
  if (lang !== 'en') return reverseEn[src] || src;

  return en[src] || src;
};
